import {Box, Center, Text, Flex, Image, useMediaQuery} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import CheckIcon2 from '@assets/svgs/learn/check_2.svg'
import CloseIcon2 from '@assets/svgs/learn/close_2.svg'
import {useEffect, useState} from 'react'
import useVocabulary from './useVocabulary'
import WrongAudio from '@assets/audios/wrong.mp3'
import RightAudio from '@assets/audios/right.mp3'
import {randomElementIndexInArray} from '@utils'

const ChoosePicture = ({
  currentVocabulary,
  setCurrentIndexQuestion,
}: {
  currentVocabulary: any
  setCurrentIndexQuestion: any
}) => {
  const [currentPicture, setCurrentPicture] = useState<any>()
  const [isLargerThan1280] = useMediaQuery('(min-width: 1600px)')
  const {handlePlayAudio} = useVocabulary()
  const [choices, setChoices] = useState<any>()

  useEffect(() => {
    if (!currentVocabulary?.vocabularyQuestionData?.answers) return
    setChoices(
      randomElementIndexInArray(
        currentVocabulary?.vocabularyQuestionData?.answers,
      ),
    )
  }, [currentVocabulary])

  const handleClickImage = (item: any) => {
    if (currentPicture) {
      return
    }
    setCurrentPicture(item)
    if (item.is_true_answer) {
      handlePlayAudio(RightAudio)
      setTimeout(() => {
        setCurrentIndexQuestion((pre: number) => pre + 1)
      }, 2000)
    } else {
      handlePlayAudio(WrongAudio)
      setTimeout(() => {
        setCurrentPicture(null)
      }, 2000)
    }
  }

  return (
    <Center flexDirection={'column'} h={'100%'}>
      <Center flexDirection={'column'}>
        <Text
          fontSize={'18px'}
          color={CommonColors.primary}
          textTransform={'uppercase'}>
          {currentVocabulary?.vocabularyQuestionData.title}
        </Text>
        <Text fontSize={'24px'} color={'#404040'} mt={'12px'} fontWeight={600}>
          {currentVocabulary?.vocabularyQuestionData.textEn}
        </Text>
        <Text fontSize={'16px'} color={'#546E7A'}>
          {currentVocabulary?.vocabularyQuestionData.textVi}
        </Text>
      </Center>
      <Flex h={'40px'} my={'24px'} flexShrink={0}>
        {currentPicture && (
          <Flex
            bg={currentPicture?.is_true_answer ? '#71D78B' : '#F98D7D'}
            borderRadius={'37px'}
            p={'0px 16px'}
            alignItems={'center'}>
            <Text fontSize={'16px'} fontWeight={600} color={'white'}>
              {currentPicture?.is_true_answer
                ? 'Quá xuất sắc!'
                : 'Thử lại nhé!'}
            </Text>
          </Flex>
        )}
      </Flex>

      <Flex justifyContent={'center'} gap={{base: '24px', md: '72px'}}>
        {choices?.map((item: any, index: any) => (
          <Box
            key={index}
            flex={1}
            cursor={'pointer'}
            position={'relative'}
            borderRadius={'16px'}
            overflow={'hidden'}
            onClick={() => handleClickImage(item)}>
            {currentPicture === item && (
              <Center
                position={'absolute'}
                top={0}
                bottom={0}
                left={0}
                right={0}
                bg={currentPicture?.is_true_answer ? '#71D78BE5' : '#F98D7D'}
                zIndex={10}
                opacity={0.9}>
                <Image
                  src={currentPicture?.is_true_answer ? CheckIcon2 : CloseIcon2}
                />
              </Center>
            )}
            <Image
              src={item.image}
              w={isLargerThan1280 ? '300px' : '230px'}
              objectFit={'cover'}
              aspectRatio={'1/1'}
            />
          </Box>
        ))}
      </Flex>
    </Center>
  )
}

export default ChoosePicture
